import { $getSelection, $isRangeSelection, LexicalEditor } from 'lexical';
import { $patchStyleText } from '@lexical/selection';
import type { PopoverProps } from 'reactstrap';

/**
 * Apply CSS styles to the current text selection in the editor
 */
export const applyStyleToSelection = (
  editor: LexicalEditor,
  styles: Record<string, string>
) => {
  editor.update(() => {
    const selection = $getSelection();
    if ($isRangeSelection(selection)) {
      $patchStyleText(selection, styles);
    }
  });
};

/**
 * Shared Popover configuration for toolbar dropdown menus
 */
export const TOOLBAR_POPOVER_PROPS: Partial<PopoverProps> = {
  placement: 'bottom',
  trigger: 'legacy',
  hideArrow: true,
  delay: 0,
  container: 'body',
};

// Font size options
export const FONT_SIZES = [
  { label: 'Small', value: '12px' },
  { label: 'Normal', value: '14px' },
  { label: 'Large', value: '18px' },
  { label: 'XL', value: '24px' },
  { label: 'XXL', value: '32px' },
];

export const DEFAULT_FONT_COLOR = '#000000';
export const DEFAULT_FONT_SIZE = '14px';
